import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {ProgressBarStyled, Bar, Stripes} from './ProgressBar.style';

export class ProgressBar extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      processing: '0'
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.active && !this.props.completed) {
      this.setState({processing: '100%'});
    }
  }

  render() {
    const {duration, active, cancelled, completed} = this.props;
    const durationTime = completed || !active ? '0' : `${duration}s`;
    const processing = completed ? '100%' : this.state.processing;
    const isActived = active && !cancelled;
    const isFinished = isActived || (completed && !cancelled);
    const renderProgressBar = isFinished &&
      <Bar
        processing={processing}
        duration={durationTime}
        finished={isFinished}
      >
        <Stripes
          active={isActived}
          completed={completed}
        />
      </Bar>;
    return (
      <ProgressBarStyled active={isActived}>
        {renderProgressBar}
      </ProgressBarStyled>
    );
  }
}

ProgressBar.propTypes = {
  duration: PropTypes.number.isRequired,
  active: PropTypes.bool.isRequired,
  completed: PropTypes.bool.isRequired,
  cancelled: PropTypes.bool.isRequired
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./components/ProgressBar/ProgressBar.js